import React, { useEffect } from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import BlogContent from './components/BlogContent'

function Blog() {
  useEffect(() => {
    document.title = 'Agência Dorac - Blog'
    window.scrollTo(0, 0)
  }, [])

  return (
    <main className='relative w-full bg-dorac-bg font-display text-dorac-ink'>
      <Header />
      <BlogContent />
      <Footer />
    </main>
  )
}

export default Blog
